import { useQuery } from "@tanstack/react-query";

function parseWorkerBody(res) {
  if (typeof res?.body === "string") {
    try {
      return JSON.parse(res.body);
    } catch {
      return res.body;
    }
  }

  return res?.data ?? res ?? null;
}

export function usePostContractAgreementRequestsByAssetIds({
  callApiWithWorker,
  assetIds,
  enabled = true,
}) {
  const stableAssetIds = Array.isArray(assetIds)
    ? [...new Set(assetIds.filter(Boolean))].sort()
    : [];

  return useQuery({
    queryKey: ["contractAgreementRequestsByAssetIds", stableAssetIds.join("|")],
    enabled: Boolean(enabled && stableAssetIds.length),
    queryFn: async ({ signal }) => {
      const results = await Promise.all(
        stableAssetIds.map(async (assetId) => {
          try {
            const res = await callApiWithWorker(
              `/contractagreements/request?assetId=${encodeURIComponent(assetId)}`,
              {
                method: "POST",
                connector: "springConnector",
                signal,
              },
            );

            return [assetId, parseWorkerBody(res)];
          } catch (error) {
            const status =
              error?.statusCode ??
              error?.status ??
              error?.response?.status ??
              error?.error?.status;

            if (status === 404) {
              return [assetId, null];
            }

            console.warn(
              `Failed to load contract agreement request for assetId ${assetId}:`,
              error,
            );
            return [assetId, null];
          }
        }),
      );

      return Object.fromEntries(results);
    },
    staleTime: 30_000,
  });
}
